(function () {
  'use strict';
  const root = document.documentElement;
  let revealIO, countIO;
  const observed = new WeakSet();
  const counted = new WeakSet();
  const selector = '.hhg .reveal, .hhh__reveal, .hhp__reveal';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function reveal(el) {
    const name = el.classList.contains('reveal') ? 'in' : 'is-in';
    if (!el.classList.contains(name)) el.classList.add(name);
  }
  function count(el) {
    const target = Number(el.dataset.hhgCount);
    if (!Number.isFinite(target)) return;
    const suffix = el.dataset.hhgSuffix || '';
    const format = value => Math.round(value).toLocaleString('es-CL') + suffix;
    if (reduced) { el.textContent = format(target); return; }
    let start;
    function step(now) {
      if (start === undefined) start = now;
      const p = Math.min((now - start) / 1500, 1);
      const value = format(target * (1 - Math.pow(1 - p, 3)));
      if (el.textContent !== value) el.textContent = value;
      if (p < 1 && el.isConnected) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function init(scope) {
    try {
      if (!reduced && 'IntersectionObserver' in window) {
        if (!revealIO) revealIO = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              revealIO.unobserve(entry.target);
              reveal(entry.target);
            }
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -48px 0px' });
        if (!countIO) countIO = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              countIO.unobserve(entry.target);
              count(entry.target);
            }
          });
        }, { threshold: 0.7 });
        scope.querySelectorAll(selector).forEach(el => {
          if (!observed.has(el)) { observed.add(el); revealIO.observe(el); }
        });
        scope.querySelectorAll('[data-hhg-count]').forEach(el => {
          if (!counted.has(el)) { counted.add(el); countIO.observe(el); }
        });
      } else {
        scope.querySelectorAll(selector).forEach(reveal);
      }
      clearTimeout(window.hhgMotionFallback);
      if (!reduced && revealIO) root.classList.add('hhg-motion');
      scope.querySelectorAll('[data-hhg-quiz]').forEach(quiz => {
        if (quiz.dataset.hhgReady) return;
        quiz.dataset.hhgReady = 'true';
        const steps = [...quiz.querySelectorAll('.quiz-step')];
        const progress = quiz.querySelector('.quiz-progress');
        const bar = quiz.querySelector('.quiz-bar');
        let step = 0;
        const show = (n, focus) => {
          step = n;
          steps.forEach((el, i) => { el.hidden = i !== n; });
          const value = (n + 1) / steps.length * 100;
          progress.setAttribute('aria-valuenow', String(value));
          bar.style.width = value + '%';
          if (focus) {
            const heading = steps[n].querySelector('.quiz-q, h3');
            if (heading) { heading.tabIndex = -1; heading.focus({ preventScroll: true }); }
          }
        };
        quiz.querySelectorAll('.quiz-step[data-step] .quiz-opt').forEach(btn => btn.addEventListener('click', () => show(Math.min(step + 1, steps.length - 1), true)));
        quiz.querySelector('.quiz-restart')?.addEventListener('click', () => show(0, true));
        show(0, false);
      });
    } catch (error) {
      root.classList.remove('hhg-motion');
      scope.querySelectorAll(selector).forEach(reveal);
      console.error('HappyHarcalm home:', error);
    }
  }
  // The reference hides its header on downward scrolling and brings it back on upward scrolling.
  function initHeader() {
    const header = document.querySelector('.hh-header-section');
    if (!header || header.dataset.hhgSticky) return;
    header.dataset.hhgSticky = 'true';
    let previous = window.scrollY, ticking = false;
    function toggle(name, enabled) {
      if (header.classList.contains(name) !== enabled) header.classList.toggle(name, enabled);
    }
    function update() {
      const y = Math.max(0, window.scrollY);
      const height = header.offsetHeight;
      if (y <= height) {
        toggle('hhg-header-pinned', false);
        toggle('hhg-header-hidden', false);
      } else if (Math.abs(y - previous) >= 3) {
        toggle('hhg-header-pinned', true);
        toggle('hhg-header-hidden', y > previous);
      }
      previous = y;
      ticking = false;
    }
    window.addEventListener('scroll', () => {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initHeader, { once: true });
  else initHeader();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:select', event => event.target.querySelectorAll(selector).forEach(reveal));
})();
